import React, { useContext, useMemo } from "react";
import SelectionItem from "../../SelectionItem";
import ImgImplantation from "./images/implantation.png";
import ImgFixedProsthetics from "./images/fixedProsthetics.png";
import ImgRemovableProsthetics from "./images/removableProsthetics.png";
import "./index.scss";
import { StepContext } from "../../StepContext";
import { useTranslation } from "../../../i18n";

const ProsthesisSelect = ({
  selectStep,
  stepId
}) => {
  const {
    _t
  } = useTranslation();
  const {
    dentalData,
    toggleBottomBarInfo
  } = useContext(StepContext);
  const haveEmptyTooth = useMemo(() => {
    return dentalData && dentalData?.tooth?.length && dentalData?.tooth.some(tooth => tooth.toothElementsActive.some(el => el === "emptyTooth"));
  }, [dentalData]);
  const types = [{
    key: "implantation",
    img: ImgImplantation,
    name: _t("Имплантация"),
    description: _t("Имплантация - это самый современный способ лечения адентии у взрослых пациентов. Данная методика...")
  }, {
    key: "fixedProsthetics",
    img: ImgFixedProsthetics,
    name: _t("Несъемное протезирование"),
    description: _t("Несъемное протезирование - это возмещение недостающих зубов мостовидными протезами. Данная методика...")
  }, {
    key: "removableProsthetics",
    img: ImgRemovableProsthetics,
    name: _t("Съемное протезирование"),
    description: _t("Съемное протезирование - это возмещение недостающих зубов при помощи съемных зубных протезов...")
  }];

  function setStep(key) {
    selectStep(key);
  }

  function openBottomBar(type) {
    toggleBottomBarInfo(true, type);
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "prosthesisSelect"
  }, /*#__PURE__*/React.createElement("div", {
    className: "prosthesisSelect-list"
  }, types.map(el => /*#__PURE__*/React.createElement(SelectionItem, {
    key: el.key,
    itemKey: el.key,
    isSelected: false,
    select: () => {
      setStep(el.key);
    },
    preview: el.img,
    outerTitle: el.name,
    outerDescription: el.description,
    aboutClick: () => openBottomBar(el.key),
    disabled: el.key !== "fixedProsthetics" ? !haveEmptyTooth : false
  }))));
};

export default ProsthesisSelect;